var base = require('settings/subscription/update-subscription');

Vue.component('spark-update-subscription', {
    mixins: [base],

    data: function(){
        return {
            //dialog: null,
            update_modal: false,
            features_modal: false
        };
    },

    methods:{

        /**
         * Approve the plan update.
         */
        approvePlanUpdate() {
            this.update_modal = false;
            this.updateSubscription(this.confirmingPlan);
        },


        /**
         * Confirm the plan update with the user.
         */
        confirmPlanUpdate(plan) {
            this.update_modal = true;
            this.confirmingPlan = plan;
        },

        showPlanDetails : function(plan) {
            this.features_modal = plan.id;
            this.detailingPlan = plan;
        }
    }
});
